module.exports = __webpack_public_path__ + "img/b2-2.aa3d07d.png";